const shader = `
#include <packing>
#define NEIGHBOUR_COUNT 4
#define PRECISION 0.0001

uniform sampler2D colorMap;
uniform sampler2D tDepth;

uniform float opacity;
uniform float screenWidth;
uniform float screenHeight;
uniform float near;
uniform float far;
uniform vec2 neighbours[NEIGHBOUR_COUNT];
uniform vec3 lightDir;
uniform float expScale;
uniform float edlStrength;
uniform float radius;

varying vec2 vUv;

float readDepth(sampler2D depthSampler, vec2 coord) {
    float fragCoordZ = texture2D(depthSampler, coord).x;
    float viewZ = perspectiveDepthToViewZ(fragCoordZ, near, far);
    return far * viewZToOrthographicDepth(viewZ, near, far);
}

float ztransform(float linearDepth) {
    return 1.0 - (linearDepth - near) / (far - near);
}

float obscurance(float z, float dist) {
    float value = max(0.0, z) / dist;
    return 0.5 * value;
}

float computeObscurance(float linearDepth) {
    vec4 P = vec4(0, 0, 1, -ztransform(linearDepth));
    vec2 uvRadius = radius / vec2(screenWidth, screenHeight);

    float sum = 0.0;
    for (int c = 0; c < NEIGHBOUR_COUNT; c++) {
        vec2 N_rel_pos = uvRadius * neighbours[c];
        vec2 N_abs_pos = vUv + N_rel_pos;

        float neighbourDepth = readDepth(tDepth, N_abs_pos);
        if (neighbourDepth != 0.0) {
            float Zn = ztransform(neighbourDepth);
            float Znp = dot(vec4(N_rel_pos, Zn, 1.0), P);
            sum += obscurance(Znp, 0.05 * linearDepth);
        }
    }
    return sum;
}

void main() {
    vec4 color = texture2D(colorMap, vUv);
    float linearDepth = readDepth(tDepth, vUv);
    float f = computeObscurance(linearDepth);

    if (color.a <= PRECISION && f <= PRECISION) {
        discard;
    }

    f = exp(-expScale * f * edlStrength);
    gl_FragColor = vec4(color.rgb * f, opacity);
}
`;

export default shader;